import PromptFragmentsTable from "./components/prompt-fragments-table/promptFragmentsTable";

const PromptFragmentsTables = () => {
  return (
    <div>
      <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
        <PromptFragmentsTable />
      </div>
    </div>
  );
};

export default PromptFragmentsTables;
